import { MIXPANEL_TOKEN, MIXPANEL_DEBUG, IS_LOCAL } from '@/init/settings'

// Init mixpanel library.
// We don't have 'mixpanel' when rendering static pages.
export function initMixpanel(): void {
  // @ts-ignore Property 'mixpanel' does not exist on type 'Window'.
  if (window.mixpanel) {
    const proxyBase = IS_LOCAL ? null : window.location.origin + '/_mp'
    mixpanel.init(MIXPANEL_TOKEN, {
      debug: MIXPANEL_DEBUG,
      track_pageview: false,
      api_host: proxyBase ? proxyBase + '/api' : undefined,
      lib_base_path: proxyBase ? proxyBase + '/libs/' : undefined,
      loaded: () => {
        ;(window as any).__MIXPANEL_LOADED = true
      },
    })
  }
}
